<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 9.16667H12V7.83333H4M2 4.5V5.83333H14V4.5M6.66667 12.5H9.33333V11.1667H6.66667V12.5Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#7F7F7F'
    },
    width: {
      type: String,
      default: '16'
    },
    height: {
      type: String,
      default: '17'
    }
  }
}
</script>
